document.addEventListener("DOMContentLoaded", function() {
  const accordions = document.querySelectorAll('.product__accordion details');
  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', function () {
      if (this.open) {
        accordions.forEach((other) => {
          if (other !== this) other.removeAttribute('open');
        });
      }
    });
  });
});
